<script setup lang="ts">
import { useDocumentStore } from '@/stores/document'

const documentStore = useDocumentStore()
</script>

<template>
  <DocumentDialog v-if="documentStore.open" />
</template>
